<template>
  <PublicTemplate>
    <section class="company__CompanySection-sc-7khmx1-0 jNWpPn pb-0">
      <div class="company_wrapper ">
        <section class="HeroSingle__HeroPage-w7ry9g-0 hwsgMr hero_with_spacings fade_in">
          <div class="image_wrapper"><img src="/uploads/SAM_0724_fdf84f99ee.jpg" alt="hero single"></div>
          <div class="hero_headings">
            <div class="container">
              <h2>Câu chuyện của chúng tôi</h2>
              <h3>CMECH: Nhà cung cấp giải pháp phụ kiện cửa và cửa sổ hàng đầu</h3>
            </div>
          </div>
        </section>
        <section class="company__CompanySection-sc-7khmx1-0 jNWpPn">
          <div class="bg_grey">
            <div class="container_small">
              <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="company_heading">
                  <div class="content_center section_description content">
                    <p>Từ kiến trúc sư, nhà thiết kế đến nhà phát triển bất động sản, các lãnh đạo ngành xây dựng đều
                      chú trọng vào việc thúc đẩy thiết kế sản phẩm chất lượng cao, phát triển công nghệ xây dựng thông
                      minh sáng tạo và sử dụng vật liệu bền vững.</p>
                    <p>Trong 30 năm qua, ngành công nghiệp đã tin tưởng CMECH với các giải pháp phụ kiện cửa và cửa sổ
                      bền vững và hoàn chỉnh, bao gồm hệ thống khóa đa điểm an toàn, bản lề cửa sổ an toàn, bánh xe chịu
                      lực bền bỉ, tay nắm tiện dụng và khả năng chống ăn mòn.</p>
                    <p>CMECH được thành lập tại Hoa Kỳ và chủ yếu cung cấp dịch vụ cho các khu vực Bắc Mỹ, Châu Âu, Châu
                      Phi và Châu Á - Thái Bình Dương. Các đối tác chiến lược toàn cầu đã xây dựng mối quan hệ bền chặt
                      trong mạng lưới quốc tế của CMECH.</p>
                    <p>Đổi mới sản phẩm, phát triển bền vững môi trường và dịch vụ chất lượng cao là cam kết vững chắc
                      của chúng tôi với đối tác, đồng thời cũng là nền tảng trong công việc của chúng tôi. Điều này được
                      phản ánh rõ ràng qua các tiêu chuẩn nghiêm ngặt trong nghiên cứu, kiểm soát, thử nghiệm, thiết kế,
                      an toàn, hiệu quả năng lượng và hiệu suất.</p>
                    <p>Chúng tôi đưa nghệ thuật vào kiến trúc và đổi mới vào từng chi tiết, giúp khách hàng cải thiện
                      không gian sống và tạo ra các tòa nhà thông minh, đẹp mắt trong kỷ nguyên cạnh tranh của Công
                      nghiệp 4.0.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container_small section_paddings">
            <section class="Innovation__InnovationSection-yx262y-0 jYnJvE">
              <div class="innovation">
                <div class="innovation_image">
                  <h2 class="content_title">Văn hóa đổi mới</h2><img
                    src="/_next/static/images/innovation-458e6b014613588686414c2cd056d7d3.jpg" alt="innovation">
                </div>
                <div class="vision_mission"></div>
                <div class="values">
                  <h4>Giá trị cốt lõi</h4>
                  <div class="values_grid">
                    <div class="item"><img src="/company_values_icon_2.png" alt="values icon">
                      <h5>Đổi mới</h5>
                      <p class="section_description">Cơ sở hạ tầng công nghệ cao cùng nghiên cứu, phát triển và thử
                        nghiệm toàn diện cho phép chúng tôi đổi mới trong lĩnh vực phụ kiện cửa sổ và cửa ra vào, mang
                        lại giá trị vượt trội cho khách hàng.</p>
                    </div>
                    <div class="item"><img src="/company_values_icon_4.png" alt="values">
                      <h5>Chất lượng</h5>
                      <p class="section_description">Khách hàng của chúng tôi dựa vào nỗ lực không ngừng của chúng tôi
                        để cung cấp các sản phẩm phụ kiện cửa và cửa sổ tốt nhất thế giới, đồng thời liên tục cải thiện
                        hiệu suất.</p>
                    </div>
                    <div class="item"><img src="/company_values_icon_1.png" alt="values icon">
                      <h5>Dịch vụ</h5>
                      <p class="section_description"> <!-- -->Tính trung thực, sự tin cậy, tôn trọng và thấu hiểu là
                        những trụ cột trong dịch vụ của chúng tôi.</p>
                    </div>
                    <div class="item"><img src="/icon_sustainability.svg" alt="values icon">
                      <h5>Bền vững</h5>
                      <p class="section_description">Chúng tôi tuân thủ triết lý tôn trọng môi trường và áp dụng công
                        nghệ tiên tiến trong các giải pháp phụ kiện cửa và cửa sổ.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="bg_grey section_paddings">
            <div class="container_small">
              <div class="core_advantages">
                <div class="core_heading_text">
                  <div class="animated fadeInUp" style="animation-duration: 1s;">
                    <h3 class="content_title">CMECH: Lợi thế cốt lõi</h3><img class="mb-30"
                      src="/uploads/company_image_9555b9c31f_4e1249b357.jpg" alt="Core Advantages">
                    <p class="section_description">Với hơn 5000 đối tác cửa hàng hàng đầu, CMECH là một doanh nghiệp
                      toàn cầu thực sự. Điều này thể hiện qua mối quan hệ đối tác với hơn 5000 cửa hàng hàng đầu trên
                      toàn cầu, cùng hướng tới mục tiêu cung cấp các giải pháp phụ kiện cửa và cửa sổ hàng đầu trong
                      ngành vật liệu xây dựng thông minh.</p>
                    <div class="company_button_wrapper">
                      <div class="SiteButton__LinkWrapper-o4bfn9-0 iBTqZx link_wrapper"><a href="/partnership">Trở thành
                          đối tác của chúng tôi</a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container_small section_paddings pb-0 ">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
              <div class="core_heading_image"></div>
              <div class="company_grid">
                <div class="image_wrapper"><img src="/uploads/20201030163041_ee99ff8129.jpg" alt="company content">
                </div>
                <div class="company_side_text_wrapper">
                  <div class="company_side_text">
                    <h4>Phòng thí nghiệm thử nghiệm công nghệ cao dành cho phụ kiện cửa và cửa sổ</h4>
                    <p>Chúng tôi xây dựng các phòng thí nghiệm tiên tiến, được trang bị hiện đại để thử nghiệm sản phẩm
                      cửa và cửa sổ theo các tiêu chuẩn nghiêm ngặt nhất nhằm đáp ứng yêu cầu chất lượng cao của chúng
                      tôi.</p>
                  </div>
                </div>
                <div class="image_wrapper"><img src="/uploads/20201030163041_b0bafbf30b_315c341d32.jpg"
                    alt="company content"></div>
                <div class="company_side_text_wrapper">
                  <div class="company_side_text">
                    <h4>Thiết kế đạt giải thưởng</h4>
                    <p>Trở thành sản phẩm cao cấp trong ngành phụ kiện cửa và cửa sổ không phải là điều đạt được trong
                      ngày một ngày hai. Để trở thành nhà dẫn đầu, cần có sự đầu tư thời gian và công sức để hoàn thiện
                      tay nghề và dịch vụ. Với 30 năm thiết kế và đổi mới đẳng cấp thế giới, chúng tôi đã đạt được mục
                      tiêu này.</p>
                  </div>
                </div>
                <div class="image_wrapper"><img src="/uploads/20201030163041_e6102de210.jpg" alt="company content">
                </div>
                <div class="company_side_text_wrapper">
                  <div class="company_side_text">
                    <h4>Sự nhất quán và độ tin cậy trong sản xuất</h4>
                    <p>Chúng tôi sản xuất 20 triệu sản phẩm mỗi năm với tỷ lệ đạt tiêu chuẩn chất lượng 99,8%. Những con
                      số này cho thấy rằng CMECH đảm bảo chất lượng sản phẩm phụ kiện cửa và cửa sổ đạt mức tối ưu thông
                      qua tính nhất quán và độ tin cậy trong sản xuất.</p>
                  </div>
                </div>
                <div class="image_wrapper"><img src="/uploads/company_cmech_4_23d6c93919.jpg" alt="company content">
                </div>
                <div class="company_side_text_wrapper">
                  <div class="company_side_text">
                    <h4>Tự động hóa phụ kiện cửa và cửa sổ</h4>
                    <p>CMECH đã triển khai hệ thống sản xuất tự động hóa bằng robot, nhằm nâng cao tiêu chuẩn và chất
                      lượng sản xuất của từng sản phẩm. Phương thức sản xuất thông minh tiên tiến này củng cố vị trí
                      hàng đầu của chúng tôi trong lĩnh vực phụ kiện cửa và cửa sổ.</p>
                  </div>
                </div>
                <div class="image_wrapper"><img src="/uploads/20201030163041_bd382e9824.jpg" alt="company content">
                </div>
                <div class="company_side_text_wrapper">
                  <div class="company_side_text">
                    <h4>Công nghệ xử lý bề mặt độc đáo</h4>
                    <p>Công nghệ xử lý bề mặt M độc quyền của CMECH đã vượt qua bài kiểm tra phun muối hơn 2000 giờ, thể
                      hiện khả năng chịu nhiệt, chống hóa chất và chống thời tiết xuất sắc.</p>
                  </div>
                </div>
                <div class="image_wrapper"><img src="/uploads/company_cmech_6_c54520a0ac_b7624fd348.png"
                    alt="company content"></div>
                <div class="company_side_text_wrapper">
                  <div class="company_side_text">
                    <h4>Thử nghiệm vòng đời phụ kiện cửa và cửa sổ</h4>
                    <p>Để đảm bảo chất lượng tốt nhất, mỗi sản phẩm phải trải qua thử nghiệm độ bền, độ chịu lực và hiệu
                      suất trước khi phát hành. Bạn đã sẵn sàng trải nghiệm giải pháp phụ kiện cửa và cửa sổ hàng đầu
                      cho phát triển thông minh chưa? Hãy liên hệ với chúng tôi!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </PublicTemplate>
</template>

<script>
import PublicTemplate from '@/templates/PublicTemplate.vue';
export default {
  name: 'CompanyView',
  components: {
    PublicTemplate
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>


<style lang="less">
.iBTqZx {
  margin-top: 50px;
  text-align: center;
  display: grid;
  place-items: center;
}

/*!sc*/
.iBTqZx a {
  font-size: 0.5em;
  -webkit-letter-spacing: 1.4px;
  -moz-letter-spacing: 1.4px;
  -ms-letter-spacing: 1.4px;
  letter-spacing: 1.4px;
  color: #050505;
  -webkit-text-decoration: none;
  text-decoration: none;
  padding: 15px 60px;
  border: 1px solid #0b0b0b;
  border-radius: 4px;
  text-transform: capitalize;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  display: inline;
  text-transform: uppercase;
}

/*!sc*/
@media (max-width:1024px) {
  .iBTqZx a {
    font-size: 0.7em;
    padding: 12px 50px;
  }
}

/*!sc*/
.iBTqZx a:hover {
  background: var(--brand_black);
  color: #fff;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
data-styled.g4[id="SiteButton__LinkWrapper-o4bfn9-0"] {
  content: "iBTqZx,"
}

/*!sc*/
.hWBHX {
  background: var(--brand_black);
  opacity: 0;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  overflow: hidden;
}

/*!sc*/
.hWBHX.fade_in {
  opacity: 1;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper {
  padding-top: 40px;
  padding-bottom: 40px;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper {
    padding-top: 50px;
    padding-bottom: 15px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  -webkit-column-gap: 90px;
  column-gap: 90px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    grid-template-columns: 1fr;
  }
}

/*!sc*/
@media (max-width:480px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    text-align: center;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
  margin-bottom: 55px;
  color: white;
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
    margin-bottom: 30px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
  height: 34px;
  margin-right: 15px;
  fill: white;
  padding-top: 6px;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
    height: 26px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap {
  margin-bottom: 35px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap p {
  color: #fff;
  text-align: left;
  margin-bottom: 15px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
  display: block;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
    padding-bottom: 60px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
  place-items: left;
  display: block;
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
    place-items: center;
    text-align: center;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a {
  color: white;
  border: 1px solid white;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a:hover {
  color: var(--brand_black);
  background-color: white;
  -webkit-transform: translateY(-3px);
  -ms-transform: translateY(-3px);
  transform: translateY(-3px);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
  padding-top: 75%;
  display: block;
  -webkit-text-decoration: none;
  text-decoration: none;
  overflow: hidden;
  position: relative;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
    display: none;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image img {
  height: 100%;
  display: block;
  position: absolute;
  object-fit: cover;
  object-position: center;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/*!sc*/
data-styled.g5[id="LearnHow__LearnHowWrap-bgqo87-0"] {
  content: "hWBHX,"
}

/*!sc*/
.hwsgMr {
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: var(--brand_black);
  opacity: 0;
  display: block;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  margin-top: 140px;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr {
    margin-top: 50px;
  }
}

/*!sc*/
.hwsgMr.fade_in {
  opacity: 1;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hwsgMr:before {
  content: ' ';
  display: block;
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.3;
  z-index: 1;
}

/*!sc*/
.hwsgMr .glide .glide__track .glide__slide {
  height: 70vh;
  min-height: 600px;
  position: relative;
  width: 100%;
  overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr .glide .glide__track .glide__slide {
    height: 600px;
    min-height: 300px;
  }
}

/*!sc*/
@media (max-width:768px) {
  .hwsgMr .glide .glide__track .glide__slide {
    height: 300px;
    min-height: 300px;
  }
}

/*!sc*/
.hwsgMr .glide .glide__track .glide__slide:before {
  content: ' ';
  display: block;
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.3;
  z-index: 1;
}

/*!sc*/
.hwsgMr .glide .glide__track .glide__slide img {
  display: block;
  position: absolute;
  object-fit: cover;
  min-width: 100%;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr .glide .glide__track .glide__slide img {
    height: 100%;
    width: auto;
  }
}

/*!sc*/
.hwsgMr .video_wrapper,
.hwsgMr .image_wrapper {
  position: relative;
}

/*!sc*/
@media (max-width:768px) {}

/*!sc*/
.hwsgMr .video_wrapper:before,
.hwsgMr .image_wrapper:before {
  content: ' ';
  display: block;
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.3;
  z-index: 1;
}

/*!sc*/
.hwsgMr .video_wrapper video,
.hwsgMr .image_wrapper video,
.hwsgMr .video_wrapper>img,
.hwsgMr .image_wrapper>img {
  display: block;
  width: 100%;
}

/*!sc*/
@media (max-width:1024px) {}

/*!sc*/
.hwsgMr video,
.hwsgMr>img {
  display: block;
  min-width: 100%;
}

/*!sc*/
.hwsgMr .hero_headings {
  position: absolute;
  z-index: 2;
  text-align: center;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: white;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr .hero_headings {
    width: 100%;
    top: 50%;
  }
}

/*!sc*/
.hwsgMr .hero_headings h2 {
  font-size: 1.7em;
  color: white;
  font-weight: 400;
  margin-bottom: 30px;
  -webkit-letter-spacing: 1.5px;
  -moz-letter-spacing: 1.5px;
  -ms-letter-spacing: 1.5px;
  letter-spacing: 1.5px;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr .hero_headings h2 {
    margin-bottom: 5px;
    font-size: 1.3em;
  }
}

/*!sc*/
.hwsgMr .hero_headings h3 {
  -webkit-text-decoration: none;
  text-decoration: none;
  color: #d8d8d8;
  -webkit-letter-spacing: 1.5px;
  -moz-letter-spacing: 1.5px;
  -ms-letter-spacing: 1.5px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-size: 0.6em;
  padding: 12px 18px;
  font-weight: 300;
}

/*!sc*/
.hwsgMr .hero_headings .hero-input {
  height: 40px;
  width: 100%;
  font-size: 15px;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr .hero_headings .hero-input {
    height: 35px;
    font-size: 14px;
    margin-top: 16px;
  }
}

/*!sc*/
.hwsgMr .hero_headings .hero-input input {
  width: 100%;
  height: 100%;
  display: block;
  background-color: white;
  border: 0;
  outline: 0;
  padding: 16px;
  margin: 0 auto;
}

/*!sc*/
@media (max-width:1024px) {
  .hwsgMr .hero_headings .hero-input input {
    width: 45%;
  }
}

/*!sc*/
@media (max-width:768px) {
  .hwsgMr .hero_headings .hero-input input {
    width: 90%;
  }
}

/*!sc*/
@media (max-width:480px) {
  .hwsgMr .hero_headings .hero-input input {
    width: 90%;
  }
}

/*!sc*/
data-styled.g23[id="HeroSingle__HeroPage-w7ry9g-0"] {
  content: "hwsgMr,"
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation {
    padding: 0 15px;
  }
}

/*!sc*/
.jYnJvE .innovation .innovation_image {
  text-align: center;
  padding-bottom: 0px;
}

/*!sc*/
.jYnJvE .innovation .innovation_image img {
  display: block;
  max-width: 100%;
}

/*!sc*/
.jYnJvE .innovation .vision_mission {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  padding: 40px 0;
  gap: 15px;
  margin-bottom: 0px;
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation .vision_mission {
    margin-bottom: 0px;
  }
}

/*!sc*/
.jYnJvE .innovation .vision_mission .item {
  border: 1px solid var(--border_grey);
  padding: 30px 15px;
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation .vision_mission .item {
    padding: 15px;
  }

  .jYnJvE .innovation .vision_mission .item .section_description {
    margin: 0;
  }
}

/*!sc*/
.jYnJvE .innovation .vision_mission .item h4 {
  font-size: 0.9em;
  margin-bottom: 25px;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  font-weight: 400;
}

/*!sc*/
.jYnJvE .innovation .values {
  text-align: center;
}

/*!sc*/
.jYnJvE .innovation .values h4 {
  font-weight: 400;
  font-size: 0.9em;
  margin-bottom: 40px;
  text-transform: uppercase;
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation .values h4 {
    margin-bottom: 30px;
  }
}

/*!sc*/
.jYnJvE .innovation .values .values_grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation .values .values_grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/*!sc*/
@media (max-width:480px) {
  .jYnJvE .innovation .values .values_grid {
    grid-template-columns: 1fr;
  }
}

/*!sc*/
.jYnJvE .innovation .values .values_grid .item {
  border: 1px solid var(--border_grey);
  padding: 30px 15px;
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation .values .values_grid .item {
    padding: 15px;
  }

  .jYnJvE .innovation .values .values_grid .item .section_description {
    margin: 0;
  }
}

/*!sc*/
.jYnJvE .innovation .values .values_grid .item img {
  display: block;
  width: 55px;
  height: 55px;
  margin: 0 auto;
  margin-bottom: 10px;
}

/*!sc*/
.jYnJvE .innovation .values .values_grid .item h5 {
  font-size: 0.9em;
  margin-bottom: 25px;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  font-weight: 400;
}

/*!sc*/
@media (max-width:1024px) {
  .jYnJvE .innovation .values .values_grid .item h5 {
    margin-bottom: 10px;
  }
}

/*!sc*/
data-styled.g167[id="Innovation__InnovationSection-yx262y-0"] {
  content: "jYnJvE,"
}

/*!sc*/
.jNWpPn {
  padding-bottom: 80px;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn {
    padding-bottom: 30px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper {
  -webkit-transition: var(--transition);
  transition: var(--transition);
  padding-bottom: 0;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper {
    padding: 80px 0;
  }
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper {
    padding: 60px 0;
    padding-top: 0;
    padding-bottom: 0;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small {
  overflow: hidden;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading {
  text-align: center;
  padding-bottom: 80px;
  padding-top: 80px;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper .container_small .company_heading {
    padding-bottom: 60px;
    padding-top: 60px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading .logo {
  text-align: center;
  margin-bottom: 30px;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading .logo svg {
  width: 180px;
}

/*!sc*/
@media (max-width:1024px) {

  .jNWpPn .company_wrapper .container_small .company_heading h4,
  .jNWpPn .company_wrapper .container_small .company_heading h2 {
    text-align: left;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading h3 {
  font-size: 0.7em;
  font-weight: 500;
  color: #424242;
  margin-bottom: 34px;
  line-height: 1.1;
  text-transform: uppercase;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper .container_small .company_heading h3 {
    margin-bottom: 20px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading h1 {
  font-size: 1.38em;
  font-weight: 300;
  color: #424242;
  line-height: 1.1;
  margin-bottom: 73px;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper .container_small .company_heading h1 {
    margin-bottom: 40px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading .content {
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper .container_small .company_heading .content {
    margin-bottom: 0;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading .content p {
  margin-bottom: 10px;
  text-align: left;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading .content p:last-of-type {
  margin-bottom: 0;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_heading .content p strong {
  font-size: 1.2em;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_banner {
  margin-bottom: 77px;
  overflow: hidden;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_banner .banner_heading {
  text-align: center;
  background: var(--text_black);
  padding-top: 70px;
  padding-bottom: 59px;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_banner .banner_heading h4 {
  color: #fff;
  font-size: 0.88em;
  font-weight: 400;
  line-height: 1.1;
  text-transform: uppercase;
  margin-bottom: 20px;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_banner .banner_heading p {
  font-size: 0.68em;
  color: #fff;
  font-weight: 300;
  line-height: 1.1;
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.5px;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_banner .banner_image img {
  display: block;
  width: 100%;
  height: auto;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .core_advantages {
  text-align: center;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .core_advantages .core_heading_image {
  padding-bottom: 80px;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .core_advantages .core_heading_image img {
  display: block;
  max-width: 100%;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .core_advantages .core_heading_text p {
  text-align: left;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .core_advantages .core_heading_text img {
  max-width: 100%;
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .core_advantages .core_heading_text .company_button_wrapper {
  margin-top: 60px;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper .container_small .core_advantages .core_heading_text .company_button_wrapper {
    margin-top: 30px;
  }

  .jNWpPn .company_wrapper .container_small .core_advantages .core_heading_text .company_button_wrapper .link_wrapper {
    margin-top: 40px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;
  row-gap: 40px;
  overflow: hidden;
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper .container_small .company_grid {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 0 15px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .image_wrapper {
  display: block;
  padding-top: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper .container_small .company_grid .image_wrapper {
    padding-top: 75%;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .image_wrapper:nth-of-type(4n + 3) {
  grid-column-start: 2;
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper .container_small .company_grid .image_wrapper:nth-of-type(4n + 3) {
    grid-column-start: unset;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .image_wrapper img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  height: 100%;
  width: auto;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:480px) {
  .jNWpPn .company_wrapper .container_small .company_grid .image_wrapper img {
    width: 100%;
    height: auto;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper {
  position: relative;
  text-align: center;
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper {
    margin-bottom: 20px;
    margin-top: 20px;
    margin: 0;
    padding: 30px 0px;
    padding-bottom: 40px;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper .company_side_text {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 80%;
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper .company_side_text {
    width: 100%;
    position: relative;
    top: auto;
    left: auto;
    -webkit-transform: translate(0);
    -ms-transform: translate(0);
    transform: translate(0);
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper .company_side_text h4 {
  font-size: 0.88em;
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.5px;
  font-weight: 400;
  color: #000000;
  line-height: 1.1;
  margin-bottom: 36px;
  text-transform: uppercase;
}

/*!sc*/
@media (max-width:768px) {
  .jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper .company_side_text h4 {
    margin-bottom: 20px;
    font-size: 1em;
  }
}

/*!sc*/
.jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper .company_side_text p {
  font-size: 0.68em;
  color: #000000;
  line-height: 1.5;
  font-weight: 300;
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.5px;
}

/*!sc*/
@media (max-width:1024px) {
  .jNWpPn .company_wrapper .container_small .company_grid .company_side_text_wrapper .company_side_text p {
    font-size: 0.8em;
  }
}

/*!sc*/
data-styled.g168[id="company__CompanySection-sc-7khmx1-0"] {
  content: "jNWpPn,"
}

/*!sc*/
</style>